import { Injectable, signal } from '@angular/core';
import { Content, NodeModel, BatchContent, BatchResult } from '@xanadu/model';

@Injectable({
    providedIn: 'root'
})
export class TreeSignal {
    input = signal<string | undefined>(undefined);

    importEndpoint = signal<any>(undefined);
    importRequest = signal<any>(undefined);
    importCast = signal<any>(undefined);
    importConvert = signal<any>(undefined);
    import = signal<any>(undefined);
    importMany = signal<any[] | undefined>(undefined);
    importResponse = signal<any>(undefined);
    importResult = signal<any>(undefined);

    listConent = signal<NodeModel | undefined>(undefined);

    contentRoot = signal<NodeModel | undefined>(undefined);

    contentLoad = signal<NodeModel | undefined>(undefined);
}
